module.exports = __webpack_public_path__ + "img/screen1.10c4c027.jpg";